import { takeLatest, all, call, put } from "redux-saga/effects";
import {
  startApplicationDocumentsData,
  startAddNewFolder,
  startAddNewDocumnet,
  setApplicationDocumentsData,
  startRepositoryDocumentsData,
  setRepositoryDocumentsData,
  startRepositoryFilterData,
  setRepositoryFilterData,
  startOfDownloadDocument,
  completedFetch,
  completedNewAdd,
  startApplicationDocumentsFilterData,
  setApplicationDocumentsFilterData,
  startFolderDocumentsDelete,
  startFileDocumentsDelete,
} from "./documents.slice.selector";
//notification
import { setNotificationAction } from "../NotificationStore/notification.slice.selector";
import {
  getApplicationDocument,
  getRepositoryDocument,
  addNewFolder,
  addDocument,
  downloadOfDocument,
  getRepositoryFilteredDocument,
  getDocumentFilteredDocument,
  deleteDocfolder,
  deleteDocfile,
} from "../../../Apis/Documents/documents";

//(1) Watcher
function* startFetchApplicationDocuments() {
  yield takeLatest(startApplicationDocumentsData.type, setApplicationData);
}
//(1) Next
function* setApplicationData({ payload }) {
  try {
    const response_data = yield call(getApplicationDocument, payload);
    yield put(setApplicationDocumentsData(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(1.5) Watcher
function* startFetchApplicationFilterDocuments() {
  yield takeLatest(startApplicationDocumentsFilterData.type, setApplicationFilterData);
}
//(1.5) Next
function* setApplicationFilterData({ payload }) {
  try {
    const response_data = yield call(getDocumentFilteredDocument, payload);
    yield put(setApplicationDocumentsFilterData(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(2) Watcher
function* startFetchRepositoryDocuments() {
  yield takeLatest(startRepositoryDocumentsData.type, setRepositoryData);
}
//(2) Next
function* setRepositoryData({ payload }) {
  try {
    const response_data = yield call(getRepositoryDocument, payload);
    yield put(setRepositoryDocumentsData(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(2.5) Watcher
function* startFetchFilteredDocuments() {
  yield takeLatest(startRepositoryFilterData.type, setRepositoryFilteredData);
}
//(2.5) Next
function* setRepositoryFilteredData({ payload }) {
  try {
    const response_data = yield call(getRepositoryFilteredDocument, payload);
    yield put(setRepositoryFilterData(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(3) Watcher
function* startAddNewFolderWatcher() {
  yield takeLatest(startAddNewFolder.type, callForNewAddFolder);
}
//(3)Next
function* callForNewAddFolder({ payload }) {
  try {
    yield call(addNewFolder, payload.newFolderData);
    yield put(completedNewAdd());
    yield put(
      setNotificationAction({
        message: "New Folder Added Successfully",
        variant: "success",
      })
    );
    yield put(startApplicationDocumentsData(payload.tableData));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedNewAdd());
  }
}
//(4) watcher
function* startAddNewDocumentWatcher() {
  yield takeLatest(startAddNewDocumnet.type, callForUploadDocument);
}
//(4)Next
function* callForUploadDocument({ payload }) {
  // console.log(payload);
  try {
    yield call(addDocument, payload.uploadData);
    yield put(completedNewAdd());
    yield put(
      setNotificationAction({
        message: "Document Added Successfully",
        variant: "success",
      })
    );
    yield put(startApplicationDocumentsData(payload.tableData));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedNewAdd());
  }
}

//(5)Watcher
function* startDownloadOfFile() {
  yield takeLatest(startOfDownloadDocument.type, callForDownloadOfFile);
}
//(5)Next
function* callForDownloadOfFile({ payload }) {
  try {
    const data = yield call(downloadOfDocument, payload.id);
    if (data.size > 0) {
      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", payload.name);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }

    // const file = new Blob([data], { type: "application/pdf" });
    // const fileUrl = URL.createObjectURL(file);
    // const w = window.open(fileUrl, "_blank");
    // w && w.focus();

    yield put(completedFetch());

  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(6) Watcher
function* startDeleteFolderDocuments() {
  yield takeLatest(startFolderDocumentsDelete.type, deleteFolderData);
}
//(6) Next
function* deleteFolderData({ payload }) {
  try {
    const response_data = yield call(deleteDocfolder, payload);
    // yield put(setRepositoryDocumentsData(response_data));
    yield put(completedFetch());
    startApplicationDocumentsData()
    yield put(startApplicationDocumentsData({
      id: payload.parentId,
      pageIndex: 0,
      pageSize: 10,
    }));
    yield put(startRepositoryDocumentsData({
      id: payload.parentId,
      pageIndex: 0,
      pageSize: 10,
    }));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(7) Watcher
function* startDeleteFileDocuments() {
  yield takeLatest(startFileDocumentsDelete.type, deleteFileData);
}
//(7) Next
function* deleteFileData({ payload }) {
  try {
    const response_data = yield call(deleteDocfile, payload);
    // yield put(setRepositoryDocumentsData(response_data));
    yield put(completedFetch());
    yield put(startApplicationDocumentsData({
      id: payload.parentId,
      pageIndex: 0,
      pageSize: 10,
    }));
    yield put(startRepositoryDocumentsData({
      id: payload.parentId,
      pageIndex: 0,
      pageSize: 10,
    }));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}



///Accumulator
export default function* documentsSaga() {
  yield all([
    call(startFetchApplicationDocuments),
    call(startFetchApplicationFilterDocuments),
    call(startFetchRepositoryDocuments),
    call(startFetchFilteredDocuments),
    call(startAddNewFolderWatcher),
    call(startAddNewDocumentWatcher),
    call(startDownloadOfFile),
    call(startDeleteFolderDocuments),
    call(startDeleteFileDocuments),
  ]);
}
